import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Leaf, Eye, EyeOff, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { adminLogin, setToken, getToken } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (getToken()) navigate("/admin/dashboard");
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await adminLogin({ email, password });
      setToken(res.token);
      toast.success("Welcome back!");
      navigate("/admin/dashboard");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed. Check your credentials.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="dark min-h-screen bg-background text-foreground">
      <div className="flex min-h-screen items-center justify-center px-4">
        <div className="w-full max-w-md">
          <button onClick={() => navigate("/")} className="mb-6 inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-4 w-4" /> Balik sa site
          </button>
          <Card className="rounded-2xl border-border bg-card p-8 shadow-xl">
            <div className="flex items-center gap-2">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary text-primary-foreground">
                <Leaf className="h-5 w-5" />
              </span>
              <span className="font-display text-xl font-semibold">Ecentra Admin</span>
            </div>
            <h1 className="mt-6 text-2xl font-semibold tracking-tight">Distributor login</h1>
            <p className="mt-1 text-sm text-muted-foreground">Mag-sign in para makita ang leads at orders mo.</p>

            <form onSubmit={handleSubmit} className="mt-6 space-y-4" noValidate>
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" className="mt-1.5 h-11" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@ecentra.com" data-testid="admin-login-email-input" />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <div className="relative mt-1.5">
                  <Input id="password" type={show ? "text" : "password"} className="h-11 pr-10" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Ilagay ang password mo" data-testid="admin-login-password-input" />
                  <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground" aria-label={show ? "Hide password" : "Show password"}>
                    {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                  </button>
                </div>
              </div>
              <Button type="submit" className="h-11 w-full" disabled={loading} data-testid="admin-login-submit-button">
                {loading ? (<><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Nagsa-sign in...</>) : "Mag-sign in"}
              </Button>
            </form>
          </Card>
        </div>
      </div>
    </div>
  );
}
